export default __webpack_public_path__ + "static/media/people.c0276f73.png";